import PaginationResponsive from "./PaginationResponsive";

export default PaginationResponsive;
